/*
 * @Author: wuqinfa
 * @Date: 2024-02-18 16:41:28
 * @LastEditors: Please set LastEditors
 * @Description: 
 */
import {
  getCurrentUser,
  getShortUrl,
  getTeacherInfo,
} from '@/services/account';

export default {
  namespace: 'global',
  state: {
    userInfo: {},
    teacherInfo: {},
    isOpenChangePassword: false,
  },
  effects: {
    *getCurrentUser({ payload }: any, { call, put }: any): any {
      const res = yield call(getCurrentUser, payload);

      yield put({
        type: '_setState',
        payload: {
          userInfo: res.data?.account || {},
        },
      });

      return res;
    },

    *getShortUrl({ payload }: any, { call, put }: any): any {
      const res = yield call(getShortUrl, payload);
      const {
        shortUrl = '',
      } = res.data;

      return shortUrl;
    },

    *getTeacherInfo({ payload }: any, { call, put }: any): any {
      const res = yield call(getTeacherInfo, payload);
      yield put({
        type: '_setState',
        payload: {
          teacherInfo: res.data || {},
        },
      });

      return res;
    },
  },
  reducers: {
    _setState(state: any, { payload }: any) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};